import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import SwiperCore, { Autoplay, Navigation, EffectFade } from 'swiper';
SwiperCore.use([Autoplay, Navigation, EffectFade]);
import { CITIES } from '../../api/citiesPage';
import { CITIES_PAGE_INTERFACE } from '../../api/citiesPage';
import { CARDMEDIAINTERFACE } from '../../api/commonInterfaces';

import FEATUREDEXPERIENCES, {
  FEATURED_EXPERIENCES_INTERFACE,
  HOMEPAFE
} from '../../api/featuredexperiences';
import client from '../../apollo-client';
import Card from '../../components/Card';
import FeaturedExperiences from '../../components/FeaturedExperiences/FeaturedExperiences';

import Trustbar from '../../components/Trust/Trustbar';
import PageHero from '../../layouts/PageHero';
import {
  DAYTOURS_PAGE,
  DAYTOURS_PAGE_INTERFACE,
  DAY_TOUR_INTERFACE
} from '../../api/dayToursPage';

import Head from 'next/head';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../../shared-components/SwipperArrows/SwipperArrows';
import { replaceTripshepherdWithSeeSight } from '../../utils/trip-sheppered-text';

const Tours = ({ featuredExp, citydropdown, cities, dayTour }: IProps) => {
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isFirstSlide, setIsFirstSlide] = useState(false);
  const handleSlideChange = (swiper: any) => {
    setIsLastSlide(swiper.isEnd);
    setIsFirstSlide(swiper.isBeginning);
  };
  const handleSwiperInit = (swiper: any) => {
    setIsFirstSlide(swiper.isBeginning);
    setIsLastSlide(swiper.isEnd);
  };

  return (
    <>
      <Head>
        <meta
          name="og:title"
          content={'Adventure Awaits! Book Exciting Tours & Activities Today'}
        ></meta>
        <meta
          name="og:description"
          content={replaceTripshepherdWithSeeSight(dayTour?.metaDescription)}
        />
        <title>{replaceTripshepherdWithSeeSight(dayTour?.pageTitle)}</title>
        <meta
          name="description"
          content={replaceTripshepherdWithSeeSight(dayTour?.metaDescription)}
        />
        <link
          href={replaceTripshepherdWithSeeSight(dayTour?.canonical)}
          rel="canonical"
          key="canonical"
        />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>

      <section id="hero" className="relative">
        <div className="hidden md:block">
          <PageHero
            title={'The Best Way to See The World'}
            snippet={
              'Best Small Group Tours. Operating Across Canada and the United States'
            }
            media="https://res.cloudinary.com/see-sight-tours/video/upload/v1658237954/landing-page-hero_mu19mc.mp4"
            video={true}
          />
        </div>

        {/* <CitiesModal /> */}
      </section>
      <Trustbar />

      <FeaturedExperiences
        featuredExp={featuredExp}
        citydropdown={citydropdown}
      />

      <div className=" w-[90%] lg:w-[85%] 3xl:w-[70%]  max-w-[1750px] mx-auto">
        <div className="pt-3 pb-10 ">
          <h2 className="font-semibold text-lg md:text-2xl lg:text-4xl pt-12    ">
            Our Cities
          </h2>

          <Swiper
            className="swiper_123 relative "
            spaceBetween={20}
            slidesPerView={1}
            onSlideChange={(swiper: any) => handleSlideChange(swiper)}
            onInit={(swiper: any) => handleSwiperInit(swiper)}
            navigation={{ prevEl: '.prevSlide', nextEl: '.nextSlide' }}
            effect="slide"
            grabCursor
            a11y={{ enabled: true }}
            observer
            observeParents
            observeSlideChildren
            breakpoints={{
              400: {
                slidesPerView: 1.3
              },
              768: {
                slidesPerView: 2
              },
              800: {
                slidesPerView: 2.8
              },
              1024: {
                slidesPerView: 3
              },
              1200: {
                slidesPerView: 4
              }
            }}
          >
            {cities &&
              cities.map((city, index) => {
                if (city.city) {
                  return (
                    <SwiperSlide key={city.city.id}>
                      <Card
                        index={index}
                        slug={city.city.slug}
                        image={city.city.cardMedia[0]?.url}
                        cardSnippet={city.city.cardSnippet}
                        city={city.city.name}
                      />
                    </SwiperSlide>
                  );
                }
              })}
          </Swiper>
          <div id="slider-btn" className="flex justify-center mt-8">
            <div className="flex gap-2">
              <div className="prevSlide">
                <LeftSwipperArrows isFirstSlide={isFirstSlide} />
              </div>
              <div className="nextSlide">
                <RightSwipperArrows isLastSlide={isLastSlide} />{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export async function getStaticProps() {
  const { data } = await client.query<FEATURED_EXPERIENCES_INTERFACE>({
    query: FEATUREDEXPERIENCES,
    variables: {
      dayTours: true,
      multiday: true,
      airportTransfers: false
    }
  });
  const { data: citiesData } = await client.query<CITIES_PAGE_INTERFACE>(
    CITIES
  );

  const { data: { dayTour } = {} } =
    await client.query<DAYTOURS_PAGE_INTERFACE>({
      query: DAYTOURS_PAGE
    });
  return {
    props: {
      featuredExp:
        data.homePage &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data.homePage))
        ),
      citydropdown:
        data.citiesDropdown &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data.citiesDropdown))
        ),
      cities:
        citiesData.citiesPage.featured &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(
            JSON.stringify(citiesData.citiesPage.featured)
          )
        ),
      dayTour
    }
  };
}
interface IProps {
  featuredExp: HOMEPAFE;
  citydropdown: [
    {
      id: string;
      name: string;
      slug: string;
    }
  ];
  cities: [
    {
      city: {
        id: string;
        name: string;
        slug: string;
        cardSnippet: string;
        cardMedia: [CARDMEDIAINTERFACE];
      };
    }
  ];
  dayTour: DAY_TOUR_INTERFACE;
}
export default Tours;
